import type { AnyRoute } from "@tanstack/react-router";

import { createInventoryRoutes } from "./createInventoryRoutes";
import type { PartsAndInventoryRouteDeps } from "./partsAndInventoryRouteContext";

export type {
  PartsAndInventoryRouteDeps,
  PartsAndInventoryRouteFactory,
} from "./partsAndInventoryRouteContext";

export function createPartsAndInventoryRoutes(
  deps: PartsAndInventoryRouteDeps,
): AnyRoute[] {
  return [...createInventoryRoutes(deps)];
}
